import React from 'react'

interface SlIconProps extends React.SVGProps<SVGSVGElement> {
  title?: string
}

export const SlIcon = (props: SlIconProps) => {
  return (
    <svg
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>{props?.title}</title>
      <g clipPath="url(#clip0_12114_95109)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M-1.42188 1.19922H38.5798V21.1981H-1.42188V1.19922Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M-1.42188 14.5352H38.5798V21.1988H-1.42188V14.5352Z"
          fill="#FF0000"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M-1.42188 7.86719H38.5798V14.5348H-1.42188V7.86719Z"
          fill="#0000FF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.80007 9.1294H8.51053L8.24109 9.10929L7.91535 8.94843L7.54537 8.95245L7.22767 9.10929L6.97834 9.1294L6.72499 9.10929L6.40729 8.95245H6.04133L5.71559 9.11331L5.44615 9.1294H5.14856L5.00781 8.88811L5.01183 8.88006L5.45018 8.95245L5.71559 8.93234L6.04133 8.77148H6.41131L6.73303 8.93234L6.98236 8.95245L7.23169 8.92832L7.55341 8.77551H7.91535L8.24511 8.93234L8.51455 8.95245L8.9368 8.87604L8.94485 8.88811L8.80007 9.1294ZM5.42203 9.50339L5.71157 9.48329L6.03731 9.32243H6.40327L6.72499 9.47926L6.97432 9.50339L7.22365 9.47926L7.54537 9.32243H7.91132L8.23706 9.48329L8.53063 9.50339L8.71964 9.27015L8.7116 9.26211L8.51053 9.32243L8.24109 9.30232L7.91535 9.14146H7.54939L7.22767 9.30232L6.97834 9.32243L6.72901 9.30232L6.40729 9.14146H6.04133L5.71559 9.30232L5.44615 9.32243L5.24508 9.27417V9.28221L5.42203 9.50339Z"
          fill="#0000FF"
        />
        <path
          d="M4.46869 4.8399C5.25798 4.49211 6.11104 4.3125 6.97356 4.3125C7.83607 4.3125 8.68913 4.49211 9.47842 4.8399C9.74006 8.53985 8.9051 10.6369 6.97356 11.131C5.04201 10.6369 4.20705 8.53985 4.46869 4.8399Z"
          fill="#0000FF"
        />
        <path
          d="M6.97352 5.50391L7.04933 5.67582L7.23611 5.65551L7.12513 5.80711L7.23611 5.95872L7.04933 5.93841L6.97352 6.11032L6.89772 5.93841L6.71094 5.95872L6.82192 5.80711L6.71094 5.65551L6.89772 5.67582"
          fill="#FFFF00"
        />
        <path
          d="M6.2704 4.56055L6.3462 4.73246L6.53298 4.71215L6.422 4.86376L6.53298 5.01536L6.3462 4.99505L6.2704 5.16696L6.1946 4.99505L6.00781 5.01536L6.11879 4.86376L6.00781 4.71215L6.1946 4.73246"
          fill="#FFFF00"
        />
        <path
          d="M7.68446 4.56055L7.76026 4.73246L7.94705 4.71215L7.83606 4.86376L7.94705 5.01536L7.76026 4.99505L7.68446 5.16696L7.60866 4.99505L7.42188 5.01536L7.53286 4.86376L7.42188 4.71215L7.60866 4.73246"
          fill="#FFFF00"
        />
        <path
          d="M6.97451 6.48242L7.58093 7.69525L7.98521 7.15622L8.9959 8.50381C8.9959 8.56642 8.98718 8.62872 8.96998 8.68892C8.83141 9.17391 8.57755 9.61817 8.23008 9.98379C7.8826 10.3494 7.45183 10.6255 6.97451 10.7886C6.4972 10.6255 6.06642 10.3494 5.71895 9.98379C5.37147 9.61817 5.11762 9.17391 4.97905 8.68892C4.96185 8.62872 4.95313 8.56642 4.95312 8.50381L5.96382 7.15622L6.3681 7.69525L6.97451 6.48242Z"
          fill="white"
        />
        <path
          d="M4.97905 8.6875C5.00719 8.78597 5.0574 8.87674 5.12587 8.95289C5.19434 9.02905 5.27928 9.0886 5.37422 9.12701C5.46915 9.16542 5.5716 9.18168 5.67376 9.17456C5.77593 9.16744 5.87513 9.13713 5.96382 9.08592C6.06625 9.02678 6.18244 8.99565 6.30072 8.99565C6.41899 8.99565 6.53519 9.02678 6.63762 9.08592C6.74004 9.14506 6.85624 9.17619 6.97451 9.17619C7.09279 9.17619 7.20898 9.14506 7.31141 9.08592C7.41384 9.02678 7.53003 8.99565 7.64831 8.99565C7.76658 8.99565 7.88278 9.02678 7.98521 9.08592C8.0739 9.13713 8.1731 9.16744 8.27526 9.17456C8.37743 9.18168 8.47987 9.16542 8.57481 9.12701C8.66975 9.0886 8.75468 9.02905 8.82315 8.95289C8.89163 8.87674 8.94184 8.78597 8.96998 8.6875L8.9959 8.6969V9.19016C8.87763 9.19016 8.76143 9.22129 8.659 9.28043C8.55657 9.33956 8.44038 9.3707 8.32211 9.3707C8.20383 9.3707 8.08764 9.33956 7.98521 9.28043C7.88278 9.22129 7.76658 9.19016 7.64831 9.19016C7.53003 9.19016 7.41384 9.22129 7.31141 9.28043C7.20898 9.33956 7.09279 9.3707 6.97451 9.3707C6.85624 9.3707 6.74004 9.33956 6.63762 9.28043C6.53519 9.22129 6.41899 9.19016 6.30072 9.19016C6.18244 9.19016 6.06625 9.22129 5.96382 9.28043C5.86139 9.33956 5.7452 9.3707 5.62692 9.3707C5.50865 9.3707 5.39245 9.33956 5.29002 9.28043C5.18759 9.22129 5.0714 9.19016 4.95312 9.19016V8.6969"
          fill="#0000FF"
        />
        <path
          d="M4.97905 9.07812C5.00719 9.1766 5.0574 9.26736 5.12587 9.34352C5.19434 9.41968 5.27928 9.47922 5.37422 9.51763C5.46915 9.55604 5.5716 9.5723 5.67376 9.56518C5.77593 9.55807 5.87513 9.52775 5.96382 9.47654C6.06625 9.41741 6.18244 9.38627 6.30072 9.38627C6.41899 9.38627 6.53519 9.41741 6.63762 9.47654C6.74004 9.53568 6.85624 9.56682 6.97451 9.56682C7.09279 9.56682 7.20898 9.53568 7.31141 9.47654C7.41384 9.41741 7.53003 9.38627 7.64831 9.38627C7.76658 9.38627 7.88278 9.41741 7.98521 9.47654C8.0739 9.52775 8.1731 9.55807 8.27526 9.56518C8.37743 9.5723 8.47987 9.55604 8.57481 9.51763C8.66975 9.47922 8.75468 9.41968 8.82315 9.34352C8.89163 9.26736 8.94184 9.1766 8.96998 9.07812L8.9959 9.08753V9.58078C8.87763 9.58078 8.76143 9.61191 8.659 9.67105C8.55657 9.73019 8.44038 9.76132 8.32211 9.76132C8.20383 9.76132 8.08764 9.73019 7.98521 9.67105C7.88278 9.61191 7.76658 9.58078 7.64831 9.58078C7.53003 9.58078 7.41384 9.61191 7.31141 9.67105C7.20898 9.73019 7.09279 9.76132 6.97451 9.76132C6.85624 9.76132 6.74004 9.73019 6.63762 9.67105C6.53519 9.61191 6.41899 9.58078 6.30072 9.58078C6.18244 9.58078 6.06625 9.61191 5.96382 9.67105C5.86139 9.73019 5.7452 9.76132 5.62692 9.76132C5.50865 9.76132 5.39245 9.73019 5.29002 9.67105C5.18759 9.61191 5.0714 9.58078 4.95312 9.58078V9.08753"
          fill="#0000FF"
        />
        <path
          d="M4.28125 4.92757C4.34419 4.89726 4.40764 4.86801 4.47157 4.83984L4.67173 8.03692C4.71353 8.70452 4.9559 9.34395 5.36711 9.87152C5.77833 10.3991 6.33924 10.7902 6.97643 10.9938C7.61363 10.7902 8.17454 10.3991 8.58575 9.87152C8.99697 9.34395 9.23934 8.70452 9.28113 8.03692L9.48129 4.83984C9.54522 4.86801 9.60867 4.89726 9.67162 4.92757L9.47619 8.04913C9.43127 8.7666 9.16759 9.45308 8.72065 10.0161C8.27372 10.5792 7.66499 10.9918 6.97643 11.1983C6.28788 10.9918 5.67915 10.5792 5.23222 10.0161C4.78528 9.45308 4.5216 8.7666 4.47668 8.04913L4.28125 4.92757Z"
          fill="#FF0000"
        />
      </g>
      <path
        d="M11 0.699219C16.799 0.699219 21.5 5.40023 21.5 11.1992C21.5 16.9982 16.799 21.6992 11 21.6992C5.20101 21.6992 0.5 16.9982 0.5 11.1992C0.5 5.40023 5.20101 0.699219 11 0.699219Z"
        stroke="#D6D8DC"
      />
      <defs>
        <clipPath id="clip0_12114_95109">
          <path
            d="M1 11.1992C1 5.67637 5.47715 1.19922 11 1.19922C16.5228 1.19922 21 5.67637 21 11.1992C21 16.7221 16.5228 21.1992 11 21.1992C5.47715 21.1992 1 16.7221 1 11.1992Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
